<template>
    <div>
        <h3>Paramètres > Village</h3>
        <br />

        <v-snackbar
            v-model="snackbar"
            :timeout="snackbar_timeout"
            :color="snackbar_color"
            :top="true"
        >
            {{ snackbar_message }}
        </v-snackbar>

        <v-card flat class="mt-5">
            <v-card-title>
                <h6 class="primary--text">Liste des villages</h6>
                <v-spacer></v-spacer>

                <v-btn
                    rounded
                    color="primary"
                    class="text-capitalize"
                    v-if="$can('export towns')"
                >
                    <export-excel
                        :data="towns"
                        name="Villages.xls"
                        :export-fields="villages_fields"
                    >
                        Exporter
                        <v-icon right>mdi-share-outline</v-icon>
                    </export-excel>
                </v-btn>
                <v-spacer></v-spacer>

                <v-dialog v-model="dialog_edit" max-width="500px">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            rounded
                            color="primary"
                            dark
                            class="mb-2"
                            v-on="on"
                            v-if="$can('create towns')"
                        >
                            Ajouter
                            <v-icon right>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md6>
                                        <v-autocomplete
                                            v-model="editedItem.district_id"
                                            :items="arrondissements"
                                            item-text="name"
                                            item-value="id"
                                            label="Arrondissement"
                                            clearable
                                            solo
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <v-text-field
                                            v-model="editedItem.name"
                                            label="Nom du village"
                                            solo
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="info"
                                text
                                @click="dialog_edit = false"
                                >Fermer</v-btn
                            >
                            <v-btn color="primary" text @click="save"
                                >Enregistrer</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-spacer></v-spacer>

                <v-text-field
                    v-model="search"
                    @input="fetchUtils()"
                    append-icon="mdi-magnify"
                    label="Rechercher un village"
                    single-line
                    solo
                    hide-details
                >
                </v-text-field>
            </v-card-title>
        </v-card>

        <v-data-table
            v-if="towns"
            :headers="headers"
            :items="towns"
            :loading="loading"
            loading-text="Loading..."
            :mobile-breakpoint="600"
            sort-by="name"
            :page.sync="currentPage"
            :server-items-length="townTotalItems"
            :items-per-page.sync="rowsPerPageItems"
            :footer-props="footerProps"
            class="mt-2"
        >
            <template v-slot:item.action="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                    v-if="$can('edit towns')"
                >
                    mdi-pencil-outline
                </v-icon>
                <v-icon
                    small
                    @click="deleteItem(item)"
                    v-if="$can('delete towns')"
                >
                    mdi-trash-can-outline
                </v-icon>
            </template>
        </v-data-table>

        <v-layout row justify-center>
            <v-dialog v-model="dialog_deletion" max-width="290">
                <v-card>
                    <v-card-title class="headline">Suppression</v-card-title>
                    <v-card-text class="text-center">
                        Etes-vous sûr de vouloir supprimer ce village ?
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                            color="orange"
                            rounded
                            @click="dialog_deletion = false"
                        >
                            <span class="white-couleur">Non</span>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="success" rounded @click="delTown()">
                            Oui
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>

<script>
import axios from "axios";
import Permissions from "~/mixins/Permissions";

export default {
    name: "settings-town",
    mixins: [Permissions],
    data: () => ({
        del_village: null,
        del_index: null,
        search: "",
        loading: false,
        dialog_edit: false,
        dialog_deletion: false,
        headers: [
            { text: "Village", value: "name" },
            { text: "Arrondissement", value: "district.name" },
            { text: "Actions", value: "action", sortable: false }
        ],
        villages_fields: {
            Village: "name",
            Arrondissement: "district.name"
        },
        snackbar: false,
        snackbar_message: "",
        snackbar_timeout: 5000,
        snackbar_color: "",

        editedIndex: -1,
        editedItem: {
            name: "",
            district_id: null
        },
        defaultItem: {
            name: "",
            district_id: null
        },
        payload: {
            query: {}
        },
        footerProps: {
            "items-per-page-options": [5, 10, 15, 30, 50, 100, 500],
            "items-per-page-text": "Lignes par page"
        },
        uri: "/towns?include=district",
        towns: [],
        currentPage: 1,
        pagination: {
            current: 1,
            total: 0,
            rowsPerPage: 15
        },
        rowsPerPageItems: 15,
        townTotalItems: 0
    }),

    created() {
        this.loading = true;
        this.fetchUtils();
        this.$store.dispatch("fetchDistricts");
    },

    computed: {
     
        arrondissements() {
            return this.$store.getters.districts;
        },
        formTitle() {
            return this.editedIndex === -1
                ? "Nouvelle commune"
                : "Editer la commune";
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },

        rowsPerPageItems(newVal, oldVal) {
            if (newVal != oldVal) {
                this.pagination.rowsPerPage = newVal;
                this.fetchUtils();
            }
        },
        currentPage(newVal, oldVal) {
            if (newVal != oldVal) {
                this.pagination.current = newVal;
                this.fetchUtils();
            }
        }
    },

    methods: {
        async fetchUtils() {
            this.loading = true;
            let newUri =
                this.uri +
                "&page=" +
                this.pagination.current +
                "&size=" +
                this.pagination.rowsPerPage;

            if (this.search !== "") {
                newUri = newUri + "&search=" + this.search;
            }
            const results = (await axios.get(newUri)).data;

            if (results.data) {
                this.towns = results.data;
                this.currentPage = results.current_page;
                this.townTotalItems = results.total;

                this.rowsPerPageItems = parseInt(results.per_page);
                this.pagination.last_page = results.last_page;
            }
            this.loading = false;
        },

        editItem(item) {
            this.editedIndex = this.towns.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog_edit = true;
        },

        deleteItem(item) {
            this.del_index = this.towns.indexOf(item);
            this.dialog_deletion = true;
            this.del_village = item;
            this.fetchUtils();

        },

        close() {
            this.dialog_edit = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        async save() {
            if (this.editedIndex > -1) {
                await this.$store.dispatch("updateTown", this.editedItem);
                this.snackbar = true;
                this.snackbar_color = "success";
                this.snackbar_message = "Village édité avec succès !";
            } else {
                await this.$store.dispatch("createTown", this.editedItem);
                this.snackbar = true;
                this.snackbar_color = "success";
                this.snackbar_message = "Village enregistré avec succès !";
            }
            this.fetchUtils();
            this.close();
        },

        async delTown() {
            await this.$store.dispatch("deleteTown", this.del_village);
            this.dialog_deletion = false;
            this.snackbar = true;
            this.snackbar_color = "success";
            this.snackbar_message = "Village supprimé avec succès !";
            this.fetchUtils();
        }
    }
};
</script>

<style scoped>
.white-couleur {
    color: white;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/town.vue